import { apiAxios } from '../../../helpers'

export const getList = async commit => {
  commit('updateLoading', true)
  const result = await apiAxios
    .post('entities/teams/')
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data.teams)
}
export const getSelectList = async ({ commit }, payload) => {
  const set = payload.set !== false
  delete payload.set

  commit('updateLoading', true)
  const result = await apiAxios
    .post('entities/teams/select')
    .finally(_ => commit('updateLoading', false))
  if (set) commit('updateSelectList', result.data.data.teams || [])
  return result.data.data.teams || []
}
export const getOne = async (commit, idEntity, idTeam) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('entities/' + idEntity + '/teams/' + idTeam)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data.team)
}
